import styled from "styled-components";
import UiCloudUpload from "@iconscout/react-unicons/icons/uil-cloud-upload";
import { useTranslation } from "react-i18next";

const StyledUploadButton = styled.label`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 4px;
  cursor: pointer;

  height: 40px;

  /* Base/white */
  background: #ffffff;
  /* Customer blue tones/Base/Grey base L48 */
  border: 1px solid #50657c;
  border-radius: 4px;

  /* Inside auto layout */
  flex: none;
  flex-grow: 0;
  z-index: 1;

  font-weight: 600;
`;

const StyledHiddenInput = styled.input`
  display: none;
`;

export const UploadButton = ({
  onImageUpload,
  id,
  testId,
  accept,
  icon = true,
  children
}: {
  onImageUpload: (file: File) => void;
  id: string;
  testId?: string;
  accept: string;
  children?: React.ReactNode;
  icon?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <StyledUploadButton id="image-upload-button" data-testid={testId}>
      {icon && <UiCloudUpload />}
      {!children && t("upload.button.label")}
      {children}
      <StyledHiddenInput
        type="file"
        id={id}
        name=""
        accept={accept}
        onChange={e => {
          if (e.target.files !== null) {
            onImageUpload(e.target.files[0]);
          }
        }}
      />
    </StyledUploadButton>
  );
};
